<template>
    <div class="orderDetailWrap fc">
        <!-- <nav-bar></nav-bar> -->
        <div v-show="!orderDetail.newticketcode" class="top fc">
            <h3>正在努力出票中...</h3>
            <p>超过30分钟未出票请联系客服<span @click="contact">{{serviceNo}}</span></p>
        </div>
        <div v-show="orderDetail.newticketcode" class="top fc">
            <h4>我的取票码</h4>
            <!-- <p>已使用的取票码将不再保存</p> -->
            <p>有疑问请联系客服<span @click="contact">{{serviceNo}}</span></p>
        </div>
        <div class="orderDetail fc">
            <div class="movieInfo fr">
                <img class="poster" :src="orderDetail.movielogo" alt />
                <div class="basicInfo fc jsb">
                    <h2>{{orderDetail.moviename}}<span>{{orderDetail.quantity}}张</span></h2>
                    <p>{{orderDetail.playtime}} {{orderDetail.edition}}</p>
                    <p>{{orderDetail.cinema}}</p>
                    <p>{{orderDetail.moviehall}}</p>
                    <p>{{orderDetail.seat}}</p>
                </div>
            </div>
            <div class="codeInfo fc ac jc">
                <span v-show="orderDetail.newticketcode">{{orderDetail.newticketcode}}</span>
                <p v-show="!orderDetail.newticketcode">请耐心等待正在努力出票...<br>出票成功后会以短信形式通知</p>
            </div>
            <!-- <div class="cinemaInfo fc">
                <h3>{{orderDetail.cinema}}</h3>
                <p>{{orderDetail.address}}</p>
            </div> -->
            <!-- <p class="divide"></p> -->
            <div class="orderInfo fr fw">
                <!-- <div class="fr ac jsb">
                    <strong class="title">实付金额</strong>
                    <span class="amount">{{orderDetail.amount}}</span>
                </div> -->
                <p>订单号：{{orderDetail.tradeno}}</p>
                <p>购买时间：{{orderDetail.addtime}}</p>
                <p>手机号：{{orderDetail.mobile}}</p>
                <p>付款方式：{{orderDetail.paymethodtext}}</p>
            </div>
            <button @click="confirm" class="confirm">确定</button>
            <!-- <div class="tips fc ac">
                <p>少量影院可能会实行3D眼镜押金制度，</p>
                <p>请您提前准备好现金，以免延误观影</p>
                <div class="service fr ac">
                    <img src="../../../static/imgs/movie/dialPhone.png" alt="">
                    <span> 如订单有问题请拨打：<strong>400-820-1350</strong></span>
                </div>
            </div> -->
        </div>
        <p class="notice">少量影院可能会实行3D眼镜押金制度<br>请您提前准备好现金,以免延误观影</p>
        <div v-show="showShare" class="shareLayer">
            <div class="envelope fc ac">
                <span>给朋友们送些电影红包</span>
                <button @click="shareToApps">立即赠送</button>
            </div>
            <img @click="closeLayer" class="close" src="../../../static/imgs/movie/close_layer.png" alt="">
        </div>
        <transition name="appsLayer">
            <div v-show="showApps" class="appsLayer fc">
                <h4>要赠至:</h4>
                <div class="list fr jsb">
                    <div class="item fc ac">
                        <img src="../../../static/imgs/movie/wechat_pay.png" alt="">
                        <span>微信</span>
                    </div>
                    <div class="item fc ac">
                        <img src="../../../static/imgs/movie/qq.png" alt="">
                        <span>QQ</span>
                    </div>
                    <div class="item fc ac">
                        <img src="../../../static/imgs/movie/ali_pay.png" alt="">
                        <span>支付宝</span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
export default {
    data() {
        return {
            tradeno: this.$route.query.tradeno,
            orderDetail: {},
            showShare: false,
            showApps: false,
            serviceNo: this.getLocal("serviceNo")
        };
    },
    components: {
        navBar
    },
    created() {
        this.getOrderDetail();
    },
    methods: {
        getOrderDetail() {
            this.$post({
                method: "member.paidorder.detail",
                tradeno: this.tradeno,
                auth_code: this.getLocal("auth_code")
            }).then(res => {
                if (res.success) {
                    this.orderDetail = res.data.order;
                }
            });
        },
        confirm(){
            history.go(-1)
        },
        contact(){
            let serviceNo  = this.getLocal("serviceNo");
            window.location.href = "tel://" + serviceNo;
        },
        shareToApps(){
            this.showApps = true;
        },
        closeLayer(){
            this.showApps = false;
            this.showShare = false;
        }
    }
};
</script>
<style scoped lang="scss">
.orderDetailWrap {
    .top {
        width: 100%;
        height: 276px;
        position: fixed;
        top: 0;
        background-image: url(../../../static/imgs/movie/top_bg.png);
        background-size: cover;
        background-position: center;
        color: #fff;
        h3 {
            font-size: 36px;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            margin: 30px 0;
            letter-spacing: 4px;
        }
        h4 {
            font-size: 36px;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            margin: 30px 0 15px 0;
            letter-spacing: 4px;
        }
        p {
            font-size: 28px;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            line-height: 36px;
            letter-spacing: 3px;
            span {
                text-decoration: underline;
            }
        }
    }
    .orderDetail {
        width: calc(100% - 40px);
        margin: 170px 20px 20px 20px;
        background: #fff;
        border-radius: 10px;
        z-index: 3;
        box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
        .movieInfo {
            width: 100%;
            padding: 40px;
            box-sizing: border-box;
            .basicInfo {
                width: calc(100% - 200px);
                h2 {
                    font-size: 32px;
                    margin-bottom: 10px;
                    span {
                        font-size: 28px;
                        color: #E42F46;
                        margin-left: 15px;
                    }
                }
                p {
                    font-size: 24px;
                    line-height: 34px;
                    color: #999;
                }
            }
            .poster {
                width: 170px;
                height: 225px;
                margin-right: 30px;
            }
        }
        // .movieInfo:before, .movieInfo:after {
        //     content: "";
        //     width: 30px;
        //     height: 30px;
        //     background-color: #f2f2f2;
        //     position: absolute;
        //     top: 250px;
        //     border-radius: 50%;
        // }
        // .movieInfo:before {
        //     left: 6px;
        // }
        // .movieInfo:after {
        //     right: 6px;
        // }
        .codeInfo {
            width: 100%;
            height: 280px;
            border-top: 1px dashed #C9C9C9;
            span {
                width: 100%;
                height: 84px;
                line-height: 84px;
                text-align: center;
                font-size: 32px;
                color: #333;
            }
            p {
                font-size: 32px;
                text-align: center;
                line-height: 40px;
            }
        }
        .cinemaInfo {
            padding: 30px;
            h3 {
                font-size: 32px;
                margin-bottom: 20px;
            }
            p {
                font-size: 24px;
                line-height: 32px;
                color: #666;
            }
        }
        .orderInfo {
            width: 100%;
            padding: 25px 40px;
            box-sizing: border-box;
            border-top: 1px dashed #C9C9C9;
            .title {
                font-size: 32px;
                font-weight: bold;
            }
            .amount {
                font-size: 32px;
                font-weight: bold;
                color: #999;
            }
            p {
                width: 50%;
                font-size: 22px;
                height: 50px;
                line-height: 50px;
                color: #999;
            }
            p:nth-child(2n){
                padding-left: 20px;
                box-sizing: border-box;
            }
        }
        .confirm {
            width: 240px;
            height: 60px;
            line-height: 60px;
            margin: 30px auto 50px auto;
            font-size: 32px;
            color: #fff;
            background: #F90040;
            border-radius: 5px;
        }
        .tips {
            width: 100%;
            padding: 40px;
            box-sizing: border-box;
            font-size: 24px;
            margin-top: 20px;
            border-top: 2px dashed #ededed;
            p {
                color: #ef5200;
                height: 40px;
                line-height: 40px;
            }
            .service {
                margin-top: 20px;
                img {
                    width: 50px;
                    height: 50px;
                    margin-right: 20px;
                }
                strong {
                    color: #ef5200;
                }
            }
        }
    }
    .notice {
        text-align: center;
        font-size: 22px;
        color: #999;
        line-height: 36px;
        margin-top: 20px;
    }
    .shareLayer {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba($color: #000000, $alpha: 0.6);
        z-index: 10;
        .envelope {
            width: 480px;
            height: 590px;
            position: absolute;
            top: 285px;
            left: 135px;
            background-image: url(../../../static/imgs/movie/envelope.png);
            background-size: cover;
            background-position: center;
            span {
                font-size: 36px;
                color: #F4BA73;
                margin: 200px 0;
            }
            button {
                width: 360px;
                height: 80px;
                border-radius: 40px;
                background: #F4BA73;
                color: #AB6C2F;
            }
        }
        .close {
            width: 40px;
            height: 80px;
            position: absolute;
            top: 205px;
            right: 163px;
        }
    }
    .appsLayer {
        width: 100%;
        position: fixed;
        bottom: 0;
        z-index: 11;
        background: #fff;
        font-size: 28px;
        h4 {
            width: 100%;
            height: 68px;
            line-height: 68px;
            padding: 0 35px;
            box-sizing: border-box;
            
        }
        .list {
            height: 156px;
            width: 100%;
            padding: 0 176px;
            box-sizing: border-box;
            .item {
                img {
                    width: 76px;
                    height: 76px;
                    margin-bottom: 28px;
                }
            }
        }
    }
    .appsLayer-enter {
        transform: translateY(224px);
    }
    .appsLayer-enter-active {
        transition: all 0.5s;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/orderDetail.vue